import styled from '@emotion/styled';
import {Button, Chip, TextField} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const DropdownWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    margin: 0 0 0.5rem 0;
    padding: 0;
`;

export const TagContentWrapper = styled.div`
    display: block;
    width: 100%;
`;

export const TextInput = styled(TextField)`
    justify-content: center;
    align-self: center;
    align-items: stretch;
    flex-grow: 2;
    max-width: 65%;
    min-width: 300px;
    margin-right: 0.5rem;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 0;
    min-width: 160px;
    max-width: 200px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

export const Tags = styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;
